import { atom } from 'recoil';

export const operationIdState = atom<string>({
  key: 'operationIdState',
  default: '',
});

export const sessionIdState = atom<string | undefined>({
  key: 'sessionIdState',
  default: undefined,
});
